export default __webpack_public_path__ + "40085ef2df8a56e5f69ff8cb8710713e.svg";